var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty1Mt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2867 14.6677C26.6548 14.6677 28.5744 12.2797 28.5744 9.33387C28.5744 6.38805 26.6548 4 24.2867 4C21.9187 4 19.999 6.38805 19.999 9.33387C19.999 12.2797 21.9187 14.6677 24.2867 14.6677Z",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2283 38.9579C13.8333 37.5826 15.0489 34.7701 13.9434 32.676C12.8378 30.5818 9.82977 29.9991 7.2247 31.3744C4.61964 32.7497 3.40404 35.5622 4.50959 37.6564C5.61515 39.7505 8.6232 40.3332 11.2283 38.9579Z",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8293 37.9793C45.0835 35.9707 44.0747 33.0776 41.5759 31.5173C39.0772 29.9571 36.0349 30.3206 34.7807 32.3293C33.5265 34.3379 34.5354 37.231 37.0341 38.7912C39.5328 40.3514 42.5751 39.9879 43.8293 37.9793Z",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3145 20.9874C38.3145 20.9874 45.3069 22.2372 42.7579 32.0294",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2491 39.7163C38.2491 39.7163 29.5673 49.7542 18.4824 33.3363",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8633 34.6964C24.8633 34.6964 27.5838 36.7879 30.1971 36.2628",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3759 16.8046C12.3759 16.8046 10.1955 10.9398 19.8253 7.83264",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7412 8.12195C28.7412 8.12195 41.6941 9.64132 33.7947 27.8103",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5183 21.4897C31.5183 21.4897 31.8225 18.0726 29.9775 16.1476",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5801 41.0683C21.5801 41.0683 17.97 47.2134 10.6064 40.2736",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79006 31.9537C5.79006 31.9537 1.59718 19.0262 21.3242 17.1903",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6238 22.6232C16.6238 22.6232 13.4827 24.004 12.6855 26.5481",
    stroke: "#0BAB47",
    strokeWidth: 2.03,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3388 34.4351C29.2774 34.4351 33.281 30.4315 33.281 25.4928C33.281 20.5541 29.2774 16.5505 24.3388 16.5505C19.4001 16.5505 15.3965 20.5541 15.3965 25.4928C15.3965 30.4315 19.4001 34.4351 24.3388 34.4351Z",
    fill: "#0BAB47",
    stroke: "white",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 19.3743H23.0321L19.8945 26.3817V28.0552H24.7057V31.1929L26.7971 30.7749V27.9513H27.9514V26.1764H26.7971V21.784L25.1756 22.2547L24.8623 26.1245H22.2474L25.333 19.3743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Mt4);
export default __webpack_public_path__ + "static/media/Property 1=mt4.82adf31b02de1dd7addbff8d569c8d96.svg";
export { ForwardRef as ReactComponent };